import maModalCameraFlow from '@/components/modalCameraFlow'
import maForm from '@/components/form'
import maButton from '@/components/button-blue'
import maNotifications from '@/components/notifications'
import maCameraWithSteps from '@/components/cameraComponent/modules/cameraWithSteps'
import maSpinner from '@/components/spinner'
import { mapState, mapActions, mapMutations } from 'vuex'
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT_MURS,
  WARRANTY_UPDATE_MURS_TOTAL_COUNT
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

// sentry
import * as Sentry from '@sentry/vue'

export default {
  name: 'cameraForm',

  mixins: [flowMixin, userFlowMixin],

  props: {
    damageReport: {
      required: true,
      type: Object
    },
    pieceId: {
      required: true,
      type: Number | null
    },
    damagedPart: {
      required: true,
      type: Object | null
    },
    pieceSurface: {
      required: true,
      type: Number | null
    },
    editIndex: {
      required: false,
      type: Number | null,
      default: null
    }
  },

  data: function () {
    return {
      formData: null,
      damageIndex: null,
      imgListEnsemble: [],
      imgListPres: [],
      isDisabledBtn: null,
      spinner: true,
      inputData: null,
      loading: true,
      photos: [],
      photoCount: 0
    }
  },

  components: {
    maModalCameraFlow,
    maForm,
    maButton,
    maNotifications,
    maSpinner,
    maCameraWithSteps
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyForms: 'forms',
      stateWarrantyCounterMurs: 'counterMurs'
    }),

    ...mapState(USER_MODULE_NAME, {
      stateUserType: 'userType'
    }),

    flowName() {
      return this.getUserFlow
    },

    report() {
      return {
        ...this.damageReport
        //SUPPORT: this.damagedPart.key
      }
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS
    }),

    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS
    }),

    showModal() {
      this.loading = true
      this.spinner = false
      if (this.editIndex === null) {
        this.getForm(this.report)
      }
      this.$refs.modalCamera.showModal = true
    },

    hideModal() {
      this.resetForms()
      this.$refs.modalCamera.showModal = false
    },

    sendEvent() {
      let event
      let payload
      switch (this.flowName) {
        case 'photoclaim':
          event = 'form:partPhotosAddedPhotoclaim'
          payload = {
            damageKey: this.damageReport.PIECE,
            pieceId: this.pieceId,
            damagedPartKey: this.damagedPart.key
          }
          break
        default:
          event = 'form:partPhotosAdded'
      }
      this.$emit(event, {
        images: this.photos,
        payload
      })
    },

    handlePhotos(photos) {
      this.photos = photos

      if (this.photos.length === 3) {
        this.sendEvent()
        this.hideModal()
      }
    },

    emitTotalPhotos() {
      this.$emit('totalPhotos', this.photoCount)
    },

    getForm(report) {
      this.formData = null
      this.actWarrantyGetForms({ report, warrantyId: this.getWarrantyId }).then(
        (resp) => {
          if (resp.formsUpdated) {
            //this.formData = this.stateWarrantyForms
            setTimeout(() => {
              //this.setSelectedValueInputs()
              setTimeout(() => {
                this.spinner = false
              }, 1000)
              this.loading = false
            })
          }
        }
      )
    },

    /**
     * Checks if the form is valid and sends the updated information to the parent component
     */

    resetForms() {
      this.damageIndex = null
      this.imgListEnsemble = []
      this.imgListPres = []
      this.photoCount = 0
      this.mutWarrantyClearForms()
    }
  }
}
